export enum TenantIconNameEnum {
  homepagePerkLeft = "homepagePerkLeft",
  homepagePerkRight = "homepagePerkRight",
  homepagePerkCenter = "homepagePerkCenter",
  homepagePerkHealth = "homepagePerkHealth",
  homepagePerkApparel = "homepagePerkApparel",
  homepagePerkElectronic = "homepagePerkElectronic",
  homepagePerkFood = "homepagePerkFood",
  homepagePerkTravel = "homepagePerkTravel",
  homepagePerkAuto = "homepagePerkAuto",
  homepagePerkAutomotive = "homepagePerkAutomotive",
  homepagePerkOutdoors = "homepagePerkOutdoors",
  hotelReservation = "hotelReservation",
  carReservation = "carReservation",
  hotelMapPin = "hotelMapPin",
  sort = "sort",
  rewards = "rewards",
  dollarCircle = "dollarCircle",
  nonRefundable = "nonRefundable",
  addTraveler = "addTraveler",
  remove = "remove",
  bookingSuccess = "bookingSuccess",
  darkChevronDown = "darkChevronDown",
  darkChevronUp = "darkChevronUp",
  refundable = "refundable",
  priceMatch = "priceMatch",
  circleCheckedItem = "circleCheckedItem",
  lock = "lock",
}
